import { useStore } from "effector-react"
import ListIcon from "remixicon-react/AlignJustifyIcon"
import GridCompactIcon from "remixicon-react/GridFillIcon"
import GridIcon from "remixicon-react/LayoutGridFillIcon"

import * as viewStore from "@/domains/auctions/store/list-view-mode"
import * as ToggleGroup from "@/ui/toggle-group"

import { View } from "../model"

export function ViewSwitch() {
  const view = useStore(viewStore.$view)

  return (
    <ToggleGroup.Root
      type="single"
      value={view}
      onValueChange={(newView) => {
        if (newView) {
          viewStore.setView(newView as View)
        }
      }}
    >
      <ToggleGroup.Item value="gridCompact">
        <GridCompactIcon size="1.5em" />
      </ToggleGroup.Item>
      <ToggleGroup.Item
        value="grid"
        css={{
          display: "none",
          "@lg": { display: "flex" },
        }}
      >
        <GridIcon size="1.5em" />
      </ToggleGroup.Item>
      <ToggleGroup.Item value="list">
        <ListIcon size="1.5em" />
      </ToggleGroup.Item>
    </ToggleGroup.Root>
  )
}
